import { useState } from "react";
import { useToast } from "../context/ToastContext";

/**
 * Runs a blob-download API call ({ blob, filename } convention from api.ts),
 * triggers the browser save, and exposes a `downloading` flag meant to be
 * OR-ed into the page's <LoadingOverlay active={...}> so the whole UI is
 * blocked while the file is being generated server-side.
 */
export function useBlockingDownload() {
  const { toast } = useToast();
  const [downloading, setDownloading] = useState(false);

  const download = async (
    fn: () => Promise<{ blob: Blob; filename: string }>,
    errMsg = "Download failed",
  ) => {
    setDownloading(true);
    try {
      const { blob, filename } = await fn();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e: any) {
      toast(e?.response?.data?.detail || errMsg, "error");
    } finally {
      setDownloading(false);
    }
  };

  return { downloading, download };
}
